import {Usage} from '../common/UsageSchema';
import {ImageGenerationResponse} from './ImageGenerationResponseSchema';

export type ImageGenerationUseCaseResult = {
  result: ImageGenerationResponse;
  usage: Usage;
};
